import { createContext } from 'react';
import initialCatalogUpdateReferencesState from './initialCatalogUpdateReferencesState';

const CatalogUpdateReferencesContext = createContext(initialCatalogUpdateReferencesState);

export default CatalogUpdateReferencesContext;
